<template>
  <CRow>
    <CCol
      col="12"
      lg="6"
    >
      <CCard no-header>
        <CCardBody>
          <h3>Role id: {{ $route.params.id }}</h3>

          <h4>Role name: {{ name }}</h4>

          <CButton
            color="primary"
            @click="goBack"
          >
            Back
          </CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Role',
  /*
  props: {
    caption: {
      type: String,
      default: 'User id'
    },
  },
  */
  data: () => {
    return {
      name: '',
    };
  },
  mounted: function () {
    let self = this;
    axios
      .get(
        this.$apiAddress +
          '/api/roles/' +
          self.$route.params.id +
          '?token=' +
          localStorage.getItem('api_token')
      )
      .then(function (response) {
        self.name = response.data.name;
      })
      .catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
